// extracted by mini-css-extract-plugin
module.exports = {"suffix":"Figure_suffix__3dqpu","percent":"Figure_percent__2Bdl3"};